<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <card>
          <template slot="header">
            <h4 class="card-title">{{editData.businessName}}</h4>
          </template>
          <div>
            <form method="get" action="/" class="form-horizontal">
              
              <div class="row">
                <div class="col-sm-4">
                  <div class="row">
                    <label class="col-sm-4 col-form-label">申請人Email</label>
                    <div class="col-sm-8">
                      <fg-input placeholder="Email" v-model="editData.bossEmail">
                        <!-- <span
                          slot="helpBlock"
                          class="form-text"
                        >A block of help text that breaks onto a new line.</span>-->
                      </fg-input>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="row">
                    <label class="col-sm-4 col-form-label">申請人電話</label>
                    <div class="col-sm-8">
                      <fg-input placeholder="Phone" v-model="editData.bossPhone">
                      </fg-input>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="row">
                    <label class="col-sm-4 col-form-label">商店統編</label>
                    <div class="col-sm-8">
                      <fg-input placeholder="Invoice" v-model="editData.invoice">
                      </fg-input>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-4" v-show="type=='gaa'">
                  <div class="row">
                    <label class="col-sm-4 col-form-label">商店名稱</label>
                    <div class="col-sm-8">
                      <fg-input placeholder="Name" v-model="editData.businessName">
                      </fg-input>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="row">
                    <label class="col-sm-4 col-form-label">商店Email</label>
                    <div class="col-sm-8">
                      <fg-input placeholder="Email" v-model="editData.businessEmail">
                        <!-- <span
                          slot="helpBlock"
                          class="form-text"
                        >A block of help text that breaks onto a new line.</span>-->
                      </fg-input>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="row">
                    <label class="col-sm-4 col-form-label">商店電話</label>
                    <div class="col-sm-8">
                      <fg-input placeholder="Phone" v-model="editData.businessPhone">
                      </fg-input>
                    </div>
                  </div>
                </div>
              </div>

              

              <div class="row">
                <div class="col-sm-4" v-show="type=='gaa'">
                  <div class="row">
                    <label class="col-sm-4 col-form-label">Wifiotg Business ID</label>
                    <div class="col-sm-8">
                      <fg-input placeholder="Address" v-model="editData.shopId">
                      </fg-input>
                    </div>
                  </div>
                </div>
                <!-- <div class="col-sm-4">
                  <div class="row">
                    <label class="col-sm-4 col-form-label">E格選單Url</label>
                    <div class="col-sm-8">
                      <fg-input placeholder v-model="editData.googleReviewUrl"></fg-input>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="row">
                    <label class="col-sm-4 col-form-label">F格選單Url</label>
                    <div class="col-sm-8">
                      <fg-input placeholder v-model="editData.FBUrl"></fg-input>
                    </div>
                  </div>
                </div> -->
              </div>
              <div class="row">
                <div class="col-sm-4" v-show="type=='gaa'">
                  <div class="row">
                    <label class="col-sm-4 col-form-label">LINE加入好友連結</label>
                    <div class="col-sm-8">
                      <fg-input placeholder v-model="editData.lineAddFriendUrl"></fg-input>
                    </div>
                  </div>
                </div>
                 <div class="col-sm-4" v-show="type=='gaa'">
                  <div class="row">
                    <label class="col-sm-4 col-form-label">LINE加入好友ID</label>
                    <div class="col-sm-8">
                      <fg-input placeholder v-model="editData.lineBasicId"></fg-input>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12">
                  <div class="row">
                    <label class="col-sm-4 col-form-label">商店地址</label>
                    <div class="col-sm-8">
                      <fg-input placeholder="Address" v-model="editData.businessAddress">
                      </fg-input>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <!-- <div class="col-md-4">
                      <div class="row">
                        <label class="col-sm-6 col-form-label">啟用LINE點餐</label>
                        <n-switch v-model="editData.isEnabled" @click.native="shopStatus()" color="green">
                            <i class="fa fa-check" slot="on"></i>
                            <i class="fa fa-exclamation" style="color:red;" slot="off"></i>
                        </n-switch>
                      </div>
                    </div> -->
                    <div class="col-md-4">
                      <div class="row">
                        <label class="col-sm-6 col-form-label">菜單樣式 <span v-if="editData.isNewStyle == true">(單欄)</span><span v-if="editData.isNewStyle !== true">(雙欄)</span></label>
                        <n-switch v-model="editData.isNewStyle">
                          <!-- <i class="now-ui-icons ui-1_check" slot="on"></i>
                          <i class="now-ui-icons ui-1_simple-remove" slot="off"></i> -->
                        <i class="fa fa-list" style="color:#BA0000;" slot="on"></i>
                        <i class="fa fa-columns" style="color:#0000BA;" slot="off"></i>
                        </n-switch>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row" v-show="type=='gaa'">
                <div class="col-sm-4">
                  <div class="row">
                    <label class="col-sm-6 col-form-label">啟用線上支付</label>
                    <n-switch v-model="editData.isMobilePayment" color="green" @click.native="checkIsMobilePayment()">
                      <i class="now-ui-icons ui-1_check" slot="on"></i>
                      <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
                    </n-switch>
                  </div>
                </div>
                <!-- <div class="col-sm-4">
                  <div class="row">
                    <label class="col-sm-6 col-form-label">啟用lala宅配</label>
                    <n-switch v-model="editData.isLala" color="green">
                      <i class="now-ui-icons ui-1_check" slot="on"></i>
                      <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
                    </n-switch>
                  </div>
                </div> -->
              </div>

              <!-- FIXME: Added by Howard. Switch to toggle auto-manual order acceptance mode. -->
              <div class="row">
                <!-- <div class="col-sm-4">
                  <div class="row">
                    <label class="col-sm-6 col-form-label">手動接單</label>
                    <n-switch v-model="editData.isManual" color="green" @input="setManualAcceptance">
                      <i class="now-ui-icons ui-1_check" slot="on"></i>
                      <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
                    </n-switch>
                  </div>
                </div> -->
                <!-- <div class="col-sm-4">
                  <div class="row">
                    <label class="col-sm-6 col-form-label">顯示統一編號欄位</label>
                    <n-switch v-model="editData.isInvoice" color="green">
                      <i class="now-ui-icons ui-1_check" slot="on"></i>
                      <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
                    </n-switch>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="row">
                    <label class="col-sm-6 col-form-label">提供收據</label>
                    <n-switch v-model="editData.isReceipt" color="green">
                      <i class="now-ui-icons ui-1_check" slot="on"></i>
                      <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
                    </n-switch>
                  </div>
                </div> -->
              </div>
              <br>

              <div class="row">
                <div class="col-sm-4">
                  <div class="row">
                    <label class="col-sm-6 col-form-label">啟用自取</label>
                    <n-switch v-model="editData.isEatIn" color="green" @click.native="checkEatInPaymentType()">
                      <i class="now-ui-icons ui-1_check" slot="on"></i>
                      <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
                    </n-switch>
                  </div>
                  <div class="row">
                    <label class="col-sm-6 col-form-label">自取現金付款</label>
                    <n-switch v-model="editData.isEatInCash" color="green">
                      <i class="now-ui-icons ui-1_check" slot="on"></i>
                      <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
                    </n-switch>
                  </div>
                  <div class="row">
                    <label class="col-sm-6 col-form-label">自取線上支付</label>
                    <n-switch v-model="editData.isEatInPay" color="green" @click.native="checkEatInPay()">
                      <i class="now-ui-icons ui-1_check" slot="on"></i>
                      <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
                    </n-switch>
                  </div>
                </div>

                <div class="col-sm-4">
                  <div class="row">
                    <label class="col-sm-6 col-form-label">啟用院內直送</label>
                    <n-switch v-model="editData.isToGo" color="green" @click.native="checkToGoPaymentType()">
                      <i class="now-ui-icons ui-1_check" slot="on"></i>
                      <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
                    </n-switch>
                  </div>
                  <div class="row">
                    <label class="col-sm-6 col-form-label">院內直送現金付款</label>
                    <n-switch v-model="editData.isToGoCash" color="green">
                      <i class="now-ui-icons ui-1_check" slot="on"></i>
                      <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
                    </n-switch>
                  </div>
                  <div class="row">
                    <label class="col-sm-6 col-form-label">院內直送線上支付</label>
                    <n-switch v-model="editData.isToGoPay" color="green" @click.native="checkToGoPay()">
                      <i class="now-ui-icons ui-1_check" slot="on"></i>
                      <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
                    </n-switch>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="row">
                    <label class="col-sm-6 col-form-label">啟用宅配</label>
                    <n-switch v-model="editData.isDelivery" color="green" @click.native="checkDeliveryPaymentType()">
                      <i class="now-ui-icons ui-1_check" slot="on"></i>
                      <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
                    </n-switch>
                  </div>
                  <div class="row">
                    <label class="col-sm-6 col-form-label">宅配現金付款</label>
                    <n-switch v-model="editData.isDeliveryCash" color="green">
                      <i class="now-ui-icons ui-1_check" slot="on"></i>
                      <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
                    </n-switch>
                  </div>
                  <div class="row">
                    <label class="col-sm-6 col-form-label">宅配線上支付</label>
                    <n-switch v-model="editData.isDeliveryPay" color="green" @click.native="checkDeliveryPay()">
                      <i class="now-ui-icons ui-1_check" slot="on"></i>
                      <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
                    </n-switch>
                  </div>
                </div>
              </div>

              <br>
              <div class="row">
                <div class="col-sm-4">
                  <div class="row">
                    <label class="col-sm-4 col-form-label">上架商品重置時間(hh:mm)</label>
                    <div class="col-sm-8">
                      <fg-input placeholder="上架商品重置時間(hh:mm)Ex 00:10" v-model="editData.resetTime"></fg-input>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="row">
                    <label class="col-sm-4 col-form-label">宅配費用</label>
                    <div class="col-sm-8">
                      <fg-input placeholder="請輸入宅配費用" type='number' min='0' v-model="editData.shippingFee"></fg-input>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="row">
                    <label class="col-sm-4 col-form-label">預估宅配天數</label>
                    <div class="col-sm-8">
                      <fg-input placeholder="請輸入宅配天數" type='number' min='0' v-model="editData.estimatedShippingDays"></fg-input>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-4">
                  <div class="row">
                    <label class="col-sm-4 col-form-label">按鈕名稱1</label>
                    <div class="col-sm-8">
                      <fg-input placeholder="請輸入按鈕名稱" v-model="editData.displayBtn1"></fg-input>
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="row">
                <label class="col-sm-4 col-form-label">營業資訊</label>
                <div class="col-sm-8">
                  <el-input
                    type="textarea"
                    placeholder=""
                    v-model="editData.storeInfo"
                    maxlength="200"
                    show-word-limit
                  >
                  </el-input>
                </div>
              </div>
              <br>

              <div class="row">
                <label class="col-sm-2 col-form-label">公告</label>
                <div class="col-sm-10">
                  <quill-editor
                    v-model="content"
                    ref="myTextEditor"
                    :options="editorOption"
                    @blur="onEditorBlur($event)"
                    @focus="onEditorFocus($event)"
                    @ready="onEditorReady($event)"
                  ></quill-editor>
                </div>
              </div>
            </form>
            <div class="row justify-content-md-center">
              <div class="col-md-3">
                <n-button native-type="button" type="gray" @click.native="home()">
                  回商店列表
                </n-button>
              </div>
              <div class="col-md-3">
                <n-button native-type="button" type="primary" @click.native="_editData()" :disabled="saveDisabled">
                  確認修改
                </n-button>
              </div>
            </div>
          </div>
        </card>
        <!-- end card -->
      </div>
    </div>
    <!-- 預約時間設定 -->
    <el-dialog title="供餐時間設定" width="40%" :visible.sync="dialogFormVisible" center>
      <br>
      <!-- datepicker -->
      <el-row>
        <el-col :span="18">
          <el-time-picker
            is-range
            v-model="timePickerValue"
            range-separator="到"
            start-placeholder="開始時間"
            end-placeholder="結束時間"
            :picker-options="timePickerOptions"
            value-format="HH:mm">
          </el-time-picker>
        </el-col>
        <el-col :span="2">
          <el-button type="warning" icon="el-icon-plus" size="small" @click="appendTimePickerArr" title="新增時間區段" style="height: 40px;">新增時段</el-button>
        </el-col>
      </el-row>
      <!-- end datepicker -->

      <el-table
          :data="timePickerObjArr"
          style="width: 100%">
        <el-table-column
          prop="start"
          label="開始時間">
        </el-table-column>
        <el-table-column
          prop="end"
          label="結束時間">
        </el-table-column>
        <el-table-column
          label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="removeTimePicker(scope)">移除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- <el-row :gutter="20" justify="center">
        <el-col class="offset-md-4">
          <el-button type="warning" icon="el-icon-plus" size="small" @click="appendTimePickerArr" title="新增時間區段">新增時段</el-button>
        </el-col>
      </el-row> -->


      <!-- <el-row v-for="(timeObj, index) in timeArr" :key="index">
        <el-col :span="9">
          <div class="sub-title">起始時間</div>
          <el-select v-model="timeObj.start" placeholder="請選擇起始時間">
            <el-option v-for="(time, index) in settingTimeArr" :key="index" :label="time.label" :value="time.value"></el-option>
          </el-select>
        </el-col>
        <el-col :span="9">
          <div class="sub-title">結束時間</div>
          <el-select v-model="timeObj.end" placeholder="請選擇結束時間">
            <el-option v-for="(time, index) in settingTimeArr" :key="'end-' + index" :label="time.label" :value="time.value"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <br>
          <el-button type="text" @click="remove(index)">移除</el-button>
        </el-col>
      </el-row> -->
      <!-- <el-row :gutter="20" justify="center">
        <el-col class="offset-md-4">
          <el-button type="warning" icon="el-icon-plus" size="small" @click="appendTimePickerArr" title="新增時間區段">新增時段</el-button>
        </el-col>
      </el-row> -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="settingConfirm">確定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  Checkbox,
  Radio,
  Switch,
  FormGroupInput as FgInput
} from "src/components/index";
import { fetchShopEdit } from "./fetchData";
import { shopEdit, shopStatus } from "./updateData";
import swal from 'sweetalert2';

import axios from 'axios';

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

var type;
export default {
  components: {
    Checkbox,
    Radio,
    FgInput,
    [Switch.name]: Switch,
    quillEditor
  },
  beforeRouteEnter(to, from, next) {
    console.log("this.$route: ", to);
    let id = to.params.id;
    type = to.params.type;
    fetchShopEdit(id, type)
      .then(res => {
        console.log("res: ", res);
        next(vm => vm.setData(res.data));
      })
      .catch(err => {
        console.log("err: ", err);
      });
  },
  data() {
    return {
      saveDisabled: false,
      textarea: "",
      content: "",
      editorOption: {
        // some quill options
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],    //加粗，斜體，下劃線，刪除線
            // ['blockquote', 'code-block'],     //引用，程式碼塊
            // [{ 'header': 1 }, { 'header': 2 }],        // 標題，鍵值對的形式；1、2表示字型大小
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],     //列表
            // [{ 'script': 'sub'}, { 'script': 'super' }],   // 上下標
            // [{ 'indent': '-1'}, { 'indent': '+1' }],     // 縮排
            // [{ 'direction': 'rtl' }],             // 文字方向
            [{ 'size': ['small', false, 'large', 'huge'] }], // 字型大小
            [{ 'color': [] }, { 'background': [] }],     // 字型顏色，字型背景顏色
            // [{ 'font': [] }],     //字型
            // [{ 'align': [] }],    //對齊方式
            ['clean'],    //清除字型樣式
          ]
        },
        placeholder: '請輸入公告...',
        theme: 'snow'
      },
      title: "",
      editData:  {},
      type: type,
      dialogFormVisible: false,
      timeArr : [{
        start: "",
        end: ""
      }],
      numOfReservedDay: 0,
      timeLengthArr: [{
        label: "5分鐘",
        value: 5
      },{
        label: "10分鐘",
        value: 10
      },{
        label: "15分鐘",
        value: 15
      },{
        label: "20分鐘",
        value: 20
      },{
        label: "30分鐘",
        value: 30
      },{
        label: "60分鐘",
        value: 60
      }],
      numOfReservedDayArr: [{
        label: "1天",
        value: 1
      },{
        label: "2天",
        value: 2
      },{
        label: "3天",
        value: 3
      },{
        label: "4天",
        value: 4
      },{
        label: "5天",
        value: 5
      },{
        label: "6天",
        value: 6
      },{
        label: "7天",
        value: 7
      }],
      settingTimeArr: [],
      timeSectorLength: 15,
      timePickerOptions: {
        format: 'HH:mm'

      },
      timePickerValue: ['00:00', '23:59'],
      timePickerObjArr: [],
      timeSectorsLengthDisplay: ""
    };
  },
  methods: {
    setData: function(data) {
      console.log("data: ", data);
      this.editData = data;
      this.editData.isLala = this.editData.isLala == 1 ? true : false;
      this.editData.isMobilePayment = this.editData.isMobilePayment == 1 ? true : false;
      this.editData.isDelivery = this.editData.isDelivery == 1 ? true : false;
      this.editData.isDeliveryCash = this.editData.isDeliveryCash == 1 ? true : false;
      this.editData.isDeliveryPay = this.editData.isDeliveryPay == 1 ? true : false;
      this.editData.isEatIn = this.editData.isEatIn == 1 ? true : false;
      this.editData.isEatInCash = this.editData.isEatInCash == 1 ? true : false;
      this.editData.isEatInPay = this.editData.isEatInPay == 1 ? true : false;
      this.editData.isToGo = this.editData.isToGo == 1 ? true : false;
      this.editData.isToGoCash = this.editData.isToGoCash == 1 ? true : false;
      this.editData.isToGoPay = this.editData.isToGoPay == 1 ? true : false;
      this.editData.isMobilePayment = this.editData.isMobilePayment == 1 ? true : false;
      this.editData.isEnabled = this.editData.isEnabled == 1 ? true : false;
      this.editData.isNewStyle = this.editData.isNewStyle == 1 ? true : false;
      this.timeSectorLength = this.editData.timeSectorLength ? this.editData.timeSectorLength : 15;
      this.editData.isManual = this.editData.isManual == 1? true: false;
      this.editData.isInvoice = this.editData.isInvoice == 1? true: false;

      console.log("this.editData.content: ", this.editData.content)
      if(this.editData.content) {
        try {
          this.$refs.myTextEditor.quill.setContents(JSON.parse(this.editData.content).ops);
        } catch(err) {
          let d = {
            ops: [{"insert": this.editData.content}]
          };
          this.$refs.myTextEditor.quill.setContents(d);
          console.log(err);
        }
      }

      this.convertToTimeObjArr(data.timeSetting);
      // if(data.timeSetting) {
      //   let timeSettingArr = data.timeSetting.split(",");
      //   this.numOfReservedDay = timeSettingArr.pop();
      //   this.timeArr = timeSettingArr.map((timeStr, index) => {
      //     let start = Number(timeStr.split('-')[0]);
      //     let end = Number(timeStr.split('-')[1]);
      //     return {
      //       start,
      //       end
      //     };
      //   });

      // }
      // this.calSettingTime();
    },
    _editData: function() {
      this.editData.content = JSON.stringify(this.$refs.myTextEditor.quill.getContents());
      this.editData.version = 'newOrderTimeSetting';
      if(this.editData.timeSectorLength <= 0) {
        this.$message({
          type: 'error', message: '時間選項間隔(分鐘)請輸入大於0的數字'
        });
      } else if(this.editData.timeSectorDays < 0) {
        this.$message({
          type: 'error', message: '可預訂天數（天）請輸入大於等於0的數字'
        });
      } else {
        this.saveDisabled = true;
        shopEdit(this.editData, type)
          .then(res => {
            console.log("edit res: ", res);
            this.$message({
              type: 'success', message: '修改成功'
            });
            this.saveDisabled = false;
          })
          .catch(err => {
            console.log("edit err: ", err.stack);
            this.$message({
              type: 'error', message: '修改失敗'
            });
            this.saveDisabled = false;
          })
      }
    },
    home: function() {
      window.history.back();
    },
    shopStatus() {
      shopStatus(this.editData, type)
      .then(res => {
        swal("線上接單狀態已更改")
      })
      .catch(err => {
        console.log("err: ", err)
      });
    },
    appendTimeArr() {
      this.timeArr.push({
        start: "",
        end: ""
      });
    },
    appendTimePickerArr() {
      console.log(this.timePickerValue)
      console.log(this.timePickerObjArr)
      this.timePickerObjArr.push({
        start: this.timePickerValue[0],
        end: this.timePickerValue[1]
      });
      this.timePickerValue = ['00:00', '23:59']
    },
    settingConfirm() {
      var isChecked = true;
      console.log("this.timePickerObjArr: ", this.timePickerObjArr)
      if(this.timePickerObjArr.length > 0) {
        this.dialogFormVisible = false;
        
      } else {
        this.$message({
          type: 'error', message: '請至少設定一個時段'
        });
      }
    },
    remove(index) {
      this.timeArr.splice(index, 1);
    },
    removeTimePicker(scope) {
      this.timePickerObjArr.splice(scope.$index, 1);
    },
    // calSettingTime() {
    //   let timeSectorLength = this.editData.timeSectorLength;
    //   let sectorLenPerHr = 60 / timeSectorLength;
    //   let maxSector = 1 * 24 * sectorLenPerHr;
    //   let settingTimeArr = [];
    //   for (let sector = 0; sector <= maxSector; sector++) {
    //     let value = sector / sectorLenPerHr;
    //     if(value.toString().length <= 5) {
    //       let hr = Math.floor(value).toString().padStart(2, "0");
    //       let min = ((value % 1) * 60).toString().padStart(2, "0");
    //       settingTimeArr.push({
    //         label: `${hr}:${min}`,
    //         value: value
    //       });
    //     }
    //   }
    //   this.settingTimeArr = settingTimeArr;
    // },

    //FIXME: Added by Howard. This toggles order auto-manual acceptance (is_manual).
    setManualAcceptance() {
      let accountId = this.editData.accountId;
      let mode = this.editData.isManual? 'on': 'off';
      axios.post(
        `${process.env.VUE_APP_APIHOST}/${this.$route.params.type}/qcpos/shops/${accountId}/manual-accept/${mode}`
      )
      .then(response => {
        console.log(`Setting shop ${accountId} to ${this.editData.isManual? 'manual': 'auto'}-acceptance mode.`);
      });
    },
    checkIsMobilePayment() {
      if(!this.editData.isMobilePayment) {
        this.editData.isEatInPay = false;
        this.editData.isToGoPay = false;
        this.editData.isDeliveryPay = false;
      } else if(this.editData.isMobilePayment) {
        this.editData.isEatInPay = true;
        this.editData.isToGoPay = true;
        this.editData.isDeliveryPay = true;
      }
    },
    checkEatInPaymentType() {
      if(this.editData.isEatIn && !(this.editData.isEatInCash || this.editData.isEatInPay)) {
        this.editData.isEatInCash = true;
      }
    },
    checkToGoPaymentType() {
      if(this.editData.isToGo && !(this.editData.isToGoCash || this.editData.isToGoPay)) {
        this.editData.isToGoCash = true;
      }
    },
    checkDeliveryPaymentType() {
      if(this.editData.isDelivery && !(this.editData.isDeliveryCash || this.editData.isDeliveryPay) && !this.editData.isLala) {
        this.editData.isDeliveryCash = true;
      } else if(this.editData.isDelivery && !this.editData.isDeliveryPay && this.editData.isLala){
        if(!this.editData.isMobilePayment) {
          this.editData.isDelivery = false;
          this.$message({
            type: 'warning', message: `尚未啟用線上支付`
          });
        } else {
          this.editData.isDeliveryPay = true;
        }
      }
    },
    checkEatInPay() {
      if(!this.editData.isMobilePayment) {
        this.editData.isEatInPay = false;
        this.$message({
          type: 'warning', message: `尚未啟用線上支付`
        });
      }
    },
    checkToGoPay() {
      if(this.editData.isMobilePayment) {
        this.editData.isToGoPay = this.editData.isToGoPay;
      } else {
        this.editData.isToGoPay = false;
        this.$message({
          type: 'warning', message: `尚未啟用線上支付`
        });
      }
    },
    checkDeliveryPay() {
      if(this.editData.isMobilePayment) {
        this.editData.isDeliveryPay = this.editData.isDeliveryPay;
      } else {
        this.editData.isDeliveryPay = false;
        this.$message({
          type: 'warning', message: `尚未啟用線上支付`
        });
      }
    },
    onEditorBlur(quill) {
      console.log("editor blur!", quill);
    },
    onEditorFocus(quill) {
      console.log("editor focus!", quill);
    },
    onEditorReady(quill) {
      console.log("editor ready!", quill);
    },
    convertToTime(numArr) {
      return numArr.map(t => {
        let s_h = Math.floor(t.start)
                .toString()
                .padStart(2, "0");
        let s_m = (t.start % 1 * 60)
                .toString()
                .padStart(2, "0");
        let e_h = Math.floor(t.end)
                .toString()
                .padStart(2, "0");
        let e_m = (t.end % 1 * 60)
                .toString()
                .padStart(2, "0");
        let start = `${s_h}:${s_m}`;
        let end = `${e_h}:${e_m}`;
        return {
          start,
          end
        }
      })
      
    },
    convertToTimeObjArr(timeSettings) {
      let timeObjSectors = this.editData.timeObjSectors;
      let timeSectorDays = this.editData.timeSectorDays;

      if(timeObjSectors && timeSectorDays) {
        this.timePickerObjArr = JSON.parse(timeObjSectors);
        this.numOfReservedDay = timeSectorDays;
      } else if(timeSettings) {
        let timeSettingArr = timeSettings.split(",");
        console.log("timeSettingArr: ", timeSettingArr);
        let days = timeSettingArr.pop();
        this.numOfReservedDay = Number(days);
        this.timeArr = timeSettingArr.map((timeStr, index) => {
          let start = Number(timeStr.split('-')[0]);
          let end = Number(timeStr.split('-')[1]);
          return {
            start,
            end
          };
        });
        this.timePickerObjArr = this.convertToTime(this.timeArr);
        console.log("this.timePickerObjArr: ", this.timePickerObjArr)
      }

    }
  },
  watch: {
    // timeSectorLength: function(val) {
    //   if(val != this.editData.timeSectorLength) {
    //     this.editData.timeSectorLength = val;
    //     // this.calSettingTime();
    //     // this.timeArr = [];
    //   }
    // },
    timePickerObjArr: function() {
      this.timeSectorsLengthDisplay = `${this.timePickerObjArr.length}`;
      this.editData.timeObjSectors = this.timePickerObjArr;
    },
    numOfReservedDay: function(val) {
      this.editData.timeSectorDays = val;
    }
  }
};
</script>

<style>
  .ql-editor{
    height: 100px;
  }
</style>